// src/PasswordGate.jsx
import React, { useState } from 'react';
import './PasswordGate.css'; // updated classes

const CORRECT_PASSWORD = "GNVISA";

export default function PasswordGate({ onAccessGranted }) {
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === CORRECT_PASSWORD) {
      localStorage.setItem('hasAccess', 'true');
      onAccessGranted();
    } else {
      setError(true);
    }
  };

  return (
    <div className="gnv-password-page">
      <img src="/logo.png" alt="AI Visa" className="gnv-logo" />
      <h2 className="gnv-heading">Enter Access Password</h2>
      <form onSubmit={handleSubmit} className="gnv-password-form">
        <input
          type="password"
          placeholder="Enter password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="gnv-password-input"
        />
        <button type="submit" className="gnv-password-button">
          Enter
        </button>
        {error && <p className="gnv-password-error">Incorrect password</p>}
      </form>
    </div>
  );
}
